import React from "react";
import Cover from "./BookCover";

// Define the keyframes for the badge popping effect
const animationStyles = `
  @keyframes badgePop {
    0% { opacity: 0; transform: scale(0.5); }
    60% { transform: scale(1.15); }
    100% { opacity: 1; transform: scale(1); }
  }
`;

export default function BookCard2({ book, onView, cart, addCart, compact = false }) {
    const inCart = cart.some(c => c._id === book._id);
    const disc = b => Math.round((1 - b.price / b.orig) * 100);
    const d = disc(book);

    return (
        <>
            {/* Inject the styles so the badge animation works */}
            <style>{animationStyles}</style>

            <div
                className="book-card-wrap"
                onClick={() => onView(book)}
                style={{
                    background: "var(--cream2)",
                    overflow: "hidden",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    minWidth: compact ? "120px" : "150px",
                    transition: "all 0.3s cubic-bezier(0.16, 1, 0.3, 1)", // Smooth spring transition
                    transform: "translateY(0)",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-6px)";
                    // Added a fallback shadow in case var(--shadow-lg) is undefined in your CSS
                    e.currentTarget.style.boxShadow = "var(--shadow-lg, 0 10px 20px rgba(0,0,0,0.1))";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                }}
            >
                <div
                    style={{
                        background: `linear-gradient(180deg,${book.color}18 0%,${book.color}08 100%)`,
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        padding: "4px 0",
                        transition: "transform 0.4s ease"
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.children[0].style.transform = "scale(1.05) rotate(2deg)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.children[0].style.transform = "scale(1) rotate(0deg)";
                    }}
                >
                    <div style={{ transition: "transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)" }}>
                        <Cover book={book} w={compact ? 100 : 130} h={compact ? 140 : 182} />
                    </div>

                    {book.badge && (
                        <div style={{
                            position: "absolute", top: 10, right: 10,
                            background: book.badge === "Bestseller" ? "var(--terra)" : book.badge === "New" ? "var(--forest)" : book.badge === "Advanced" ? "var(--rose)" : "var(--gold)",
                            color: "white", fontSize: 10, fontWeight: 800,
                            borderRadius: 50, padding: "2px 8px",
                            // Updated to use a smoother easing curve
                            animation: "badgePop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both",
                            letterSpacing: "0.05em"
                        }}>
                            {book.badge}
                        </div>
                    )}

                    {d > 0 && (
                        <div style={{
                            position: "absolute", top: 10, left: 10,
                            background: "var(--cream)", color: "var(--terra)",
                            fontSize: 10, fontWeight: 800, borderRadius: 50,
                            padding: "2px 8px", border: "1.5px solid var(--terra)"
                        }}>
                            {d}% OFF
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}